import {customers} from './Customers.reducer'

export * from './Customers.action'
export * from './Customers.selector'
export * from './Action.types'

export const customersReducer = customers
